import React, { Component } from 'react';
import EnergyChartOfWeek from './EnergyChartOfWeek';
import EnergyChartOfDay from './EnergyChartOfDay';
import EnergyChartOfMonth from './EnergyChartOfMonth';
import EnergyChartOfYear from './EnergyChartOfYear';
import { Modal, Button } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { SERVER_URL } from './ServerConfig';

class EnergyGeneration extends Component {

    constructor(props) {
        super(props);
        this.state = {
            timeState: 'day',
            pendingExport: false,
            exporting: false,
            exportReportMessage: '',
            fromDate: new Date(),
            toDate: new Date()
        }
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleCloseExport = this.handleCloseExport.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handleOpenExportModal = this.handleOpenExportModal.bind(this);

        this.handleFromDateSelect = this.handleFromDateSelect.bind(this);
        this.handleToDateSelect = this.handleToDateSelect.bind(this);
    }

    getTimeButtonState(state) {
        if (this.state.timeState === state) {
            return "btn btn-default active bg-blue";
        }
        return "btn btn-default";
    }

    handleButtonClick(state) {
        this.setState({
            timeState: state
        });
    }

    handleCloseExport() {
        this.setState({
            exportReportMessage: '',
            pendingExport: false,
            exporting: false,
        });
    }

    handleExport() {
        this.setState({ exporting: true });
        const token = this.props.user.payload.token;
        const station = this.props.station;
        fetch(SERVER_URL + '/v1/stations/' + station._id + '/exportReport', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token,
            },
            body: JSON.stringify({
                fromDay: this.state.fromDate,
                toDay: this.state.toDate,
            })
        })
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    return response.blob();
                } if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    throw new Error(response);
                }
            })
            .then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = 'SolarMonitoring-Daily-report.xlsx';
                a.click();
                this.setState({
                    exportReportMessage: '',
                    exporting : false,
                    pendingExport: false
                });
            }).catch(err => {
                this.setState({ exporting : false, exportReportMessage: "Could not export report" });
            })

    }

    download(content, fileName, contentType) {
        var a = document.createElement("a");
        var file = new Blob([content], { type: contentType });
        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();
    }

    handleOpenExportModal() {
        this.setState({
            pendingExport: true,
            exporting: false,
        });
    }

    handleFromDateSelect(selectedDate) {
        this.setState({
            fromDate: selectedDate
        })
    }

    handleToDateSelect(toDate) {
        this.setState({
            toDate: toDate
        })
    }

    isOwner() {
        let user = this.props.user.payload.user;
        return user.member.mRole === 'owner';
    }

    getExportButtons() {
        if (this.isOwner()) {
            if (this.state.exporting) {
                return (
                    <Button variant="primary" className="disabled">
                        Exporting...
                    </Button>
                )
            } else {
                return (<Button variant="success" onClick={this.handleExport}>
                    Export
                </Button>);
            }
        }
    }

    getExportReportModal() {
        return (
            <Modal show={this.state.pendingExport} onHide={this.handleCloseExport} animation={false} >
                <Modal.Header closeButton>
                    <Modal.Title>Export daily energy report</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-horizontal" >
                        <div className="text-center">
                            <p className="text-danger">{this.state.exportReportMessage}</p>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">From</label>
                            <div className="col-sm-9">
                                <DatePicker dateFormat="dd/MM/yyyy"
                                    selected={this.state.fromDate}
                                    startDate={this.state.fromDate}
                                    endDate={this.state.toDate}
                                    className="day-picker-input form-control form-control-sm"
                                    onChange={date => this.handleFromDateSelect(date)} todayButton="Today" />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">To</label>
                            <div className="col-sm-9">
                                <DatePicker dateFormat="dd/MM/yyyy"
                                    selected={this.state.toDate}
                                    startDate={this.state.fromDate}
                                    endDate={this.state.toDate}
                                    minDate={this.state.fromDate}
                                    className="day-picker-input form-control form-control-sm"
                                    onChange={date => this.handleToDateSelect(date)} todayButton="Today" />
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={this.handleCloseExport}>
                        Close
                    </Button>
                    {this.getExportButtons()}
                </Modal.Footer>
            </Modal>
        );
    }

    getMainContent() {
        switch (this.state.timeState) {
            case 'day':
                return (
                    <EnergyChartOfDay user={this.props.user} station={this.props.station} />
                )
            case 'week':
                return (
                    <EnergyChartOfWeek user={this.props.user} station={this.props.station} />
                );
            case 'month':
                return (
                    <EnergyChartOfMonth user={this.props.user} station={this.props.station} />
                )
            case 'year':
                return (
                    <EnergyChartOfYear user={this.props.user} station={this.props.station} />
                )
            default:
                return (<div></div>)
        }

    }

    render() {
        return (
            <div className="main-content">
                <div className="p-2">
                    <div className="time-toggle d-inline-flex">
                        <button type="button" class="btn btn-block btn-success mr-2" onClick={this.handleOpenExportModal}>Export</button>
                        <div className="btn-group btn-group-toggle" data-toggle="buttons">
                            <label className={this.getTimeButtonState('day')} onClick={() => this.handleButtonClick('day')}>
                                <input type="radio" name="options" id="day" autoComplete="off" defaultChecked /> Day
                            </label>
                            <label className={this.getTimeButtonState('week')} onClick={() => this.handleButtonClick('week')}>
                                <input type="radio" name="options" id="week" autoComplete="off" /> Week
                            </label>
                            <label className={this.getTimeButtonState('month')} onClick={() => this.handleButtonClick('month')}>
                                <input type="radio" name="options" id="month" autoComplete="off" /> Month
                             </label>
                            <label className={this.getTimeButtonState('year')} onClick={() => this.handleButtonClick('year')}>
                                <input type="radio" name="options" id="year" autoComplete="off" /> Year
                            </label>
                        </div>
                    </div>
                    {this.getMainContent()}
                </div>
                {this.getExportReportModal()}
            </div>
        )
    }
}

export default EnergyGeneration;